// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-truncate[data-v-b68432ae]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-truncate-wrapper[data-v-b68432ae]{position:relative}.text-truncate-wrapper .dots[data-v-b68432ae]{position:absolute;left:3px}.text-truncate-wrapper.reverse[data-v-b68432ae]{padding:0 0 0 .75rem}.text-truncate-wrapper.reverse .text-truncate[data-v-b68432ae]{white-space:nowrap;display:flex;justify-content:flex-end;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
